import { gql } from '@apollo/client'

export const CurrentUserQuery = gql`
  query CurrentUserQuery {
    currentUser {
      id
      email
      displayName
      avatar {
        url
      }
      companies {
        id
        name
        darkLogo { url }
        currency
        locale
        mystroEnabled
        vatNumber
      }
    }
  }
`
